import React from "react";
import MessageInput from "./MessageInput";

interface Props {
  aiBlock: boolean;
  toggleAiBlock: () => void;
  disabled: boolean;
  selectedUserData?: any;
  onSendMessage: (msg: string, imageFile?: File, audioFile?: File, documentFile?: File) => void;
  isBusy?: boolean; 
}

const MessageInputSection: React.FC<Props> = ({
  aiBlock,
  toggleAiBlock,
  disabled,
  onSendMessage,
  isBusy = false,
  selectedUserData,
}) => (
  <div className="px-[24px] py-4 bg-[#f6f7f9]">
    <MessageInput
      onSendMessage={onSendMessage}
      disabled={disabled || isBusy}
      aiBlock={aiBlock}
      toggleAiBlock={toggleAiBlock}
      isBusy={isBusy}
      selectedUserData={selectedUserData}
    />
  </div>
);

export default MessageInputSection;
